import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

interface DialerState {
  isOpen: boolean;
  /** Número pre-llenado al abrir el dialer (ej. desde click-to-call). E.164. */
  prefill: string;
}

/**
 * Estado de la UI del widget flotante del dialer.
 *
 * El widget mismo está mounted siempre (cuando el usuario es Sales Rep). Este
 * servicio controla si está expandido o colapsado, y permite a otros módulos
 * (Contactos, Leads, etc.) abrirlo con un número pre-cargado en sub-fases
 * futuras.
 */
@Injectable({ providedIn: 'root' })
export class CallDialerService {
  private readonly _state = new BehaviorSubject<DialerState>({ isOpen: false, prefill: '' });
  readonly state$ = this._state.asObservable();

  get state(): DialerState { return this._state.value; }

  open(prefill = ''): void {
    this._state.next({ isOpen: true, prefill });
  }

  close(): void {
    this._state.next({ isOpen: false, prefill: '' });
  }

  toggle(): void {
    const cur = this._state.value;
    this._state.next({ isOpen: !cur.isOpen, prefill: cur.isOpen ? '' : cur.prefill });
  }

  clearPrefill(): void {
    this._state.next({ ...this._state.value, prefill: '' });
  }
}
